import React, { useState, useContext } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X, Sparkles as SparkIcon } from "lucide-react";
import { AuthContext } from "../App";

export default function Navbar({ particlesOn, setParticlesOn }) {
  const [open, setOpen] = useState(false);
  const { user } = useContext(AuthContext);

  const links = [
    { to: "/", label: "Home" },
    { to: "/films", label: "Films" },
    { to: "/music", label: "Music" },
    { to: "/news", label: "News" },
    { to: "/about", label: "About" },
    { to: "/contact", label: "Contact" },
  ];

  return (
    <>
      <header className="fixed top-0 left-0 right-0 z-50 jk-glass" data-testid="site-navbar">
        <div className="max-w-[1400px] mx-auto flex items-center justify-between px-6 md:px-10 py-4">
          <Link to="/" className="flex items-center gap-3 group" data-testid="nav-logo">
            <div className="bg-white rounded-lg px-2.5 py-1.5 ring-1 ring-white/10 transition-transform group-hover:scale-105">
              <img src="/brand/logo-full.webp" alt="Je Ke Pictures Pvt. Ltd." className="h-8 md:h-9 w-auto object-contain" />
            </div>
          </Link>

          <nav className="hidden lg:flex items-center gap-8">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                className={({ isActive }) => `jk-link ${isActive ? "active" : ""}`}
                data-testid={`nav-link-${l.label.toLowerCase()}`}
              >
                {l.label}
              </NavLink>
            ))}
          </nav>

          <div className="flex items-center gap-4">
            <button
              onClick={() => setParticlesOn(!particlesOn)}
              className="hidden md:flex items-center gap-2 text-xs text-[color:var(--jk-muted)] hover:text-[color:var(--jk-gold)] transition-colors font-cinzel tracking-widest"
              data-testid="toggle-particles-btn"
              title="Toggle cinematic background"
            >
              <SparkIcon size={14} />
              {particlesOn ? "FX ON" : "FX OFF"}
            </button>
            {user?.is_admin && (
              <Link to="/admin" className="jk-link hidden md:inline-block" data-testid="nav-admin-link">Admin</Link>
            )}
            <button
              className="lg:hidden text-[color:var(--jk-gold)]"
              onClick={() => setOpen(!open)}
              data-testid="mobile-menu-btn"
              aria-label="Toggle menu"
            >
              {open ? <X /> : <Menu />}
            </button>
          </div>
        </div>

        {open && (
          <div className="lg:hidden border-t border-white/5 jk-glass" data-testid="mobile-menu">
            <nav className="flex flex-col p-6 gap-5">
              {links.map((l) => (
                <NavLink
                  key={l.to}
                  to={l.to}
                  end={l.to === "/"}
                  onClick={() => setOpen(false)}
                  className={({ isActive }) => `jk-link ${isActive ? "active" : ""}`}
                  data-testid={`mobile-nav-${l.label.toLowerCase()}`}
                >
                  {l.label}
                </NavLink>
              ))}
              <button
                onClick={() => setParticlesOn(!particlesOn)}
                className="flex items-center gap-2 text-xs text-[color:var(--jk-muted)] font-cinzel tracking-widest"
                data-testid="mobile-toggle-particles"
              >
                <SparkIcon size={14} />
                {particlesOn ? "FX ON" : "FX OFF"}
              </button>
            </nav>
          </div>
        )}
      </header>
      <div className="h-[72px]" />
    </>
  );
}
